import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, ChevronDown } from "lucide-react";

export default function ThinkingPane({ text, isStreaming }) {
  const [expanded, setExpanded] = useState(true);
  const [autoCollapsed, setAutoCollapsed] = useState(false);

  // When streaming finishes, auto-collapse after a short delay so the
  // chart / final answer takes focus.
  useEffect(() => {
    if (!isStreaming && expanded && !autoCollapsed) {
      const t = setTimeout(() => {
        setExpanded(false);
        setAutoCollapsed(true);
      }, 1500);
      return () => clearTimeout(t);
    }
  }, [isStreaming, expanded, autoCollapsed]);

  return (
    <div className="border border-gray-200 border-l-2 border-l-purple-400 bg-gray-50/50 rounded-lg overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-2.5 text-left hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <motion.div
            animate={isStreaming ? { rotate: 360 } : { rotate: 0 }}
            transition={isStreaming
              ? { duration: 3, ease: "linear", repeat: Infinity }
              : { duration: 0 }
            }
          >
            <Sparkles className={`w-4 h-4 ${isStreaming ? "text-purple-500" : "text-gray-400"}`} strokeWidth={2} />
          </motion.div>
          <span className={`text-sm font-medium ${isStreaming ? "text-purple-700" : "text-gray-500"}`}>
            {isStreaming ? "Thinking…" : "Thought process"}
          </span>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${expanded ? "" : "-rotate-90"}`}
          strokeWidth={2}
        />
      </button>
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="overflow-hidden"
          >
            <div className="px-4 pb-3 text-sm italic text-gray-600 leading-relaxed whitespace-pre-wrap">
              {text}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
